import React, { Component } from 'react';
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';

// @ts-ignore FIXME: Try `npm install @types/rc-form` if it exists or a... Remove this comment to see the full error message
import { formShape } from 'rc-form';
import isEmpty from 'lodash/isEmpty';
import { Button } from '@solvhealth/jigsaw-v1';
import withStyles from '../../core/isomorphic-style-loader/withStyles';
import SymptomInput from '../Form/SymptomInput';
import AppointmentTimeInput from '../Form/AppointmentTimeInput';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module './CDPBookingForm.css' or its c... Remove this comment to see the full error message
import s from './CDPBookingForm.css';
import UserProfileSelector from '../Form/UserProfileSelector';
import { deleteUndefinedFields } from '../../core/util/object';
import { getFieldObject } from '../../core/util/rcForm/rcFormToReduxForm';
import { emptyFunction } from '../../core/util/function';
import { colors } from '../../constants/colors';
import { SmallXSvg } from './SmallXSvg';
import { AccountSummary } from '~/reducers/account';
import { ALL_WHITELABEL_PALETTES, WhiteLabelPaletteName } from '~/hooks/useWhiteLabelProperties';

const SYMPTOMS_FIELD_NAME = 'symptoms';
const APPOINTMENT_TIME_FIELD_NAME = 'appointmentTime';
const USER_PROFILE_FIELD_NAME = 'userProfile';

const emptyInteractions = {
  onBlur: emptyFunction,
  onUpdate: emptyFunction,
  onFocus: emptyFunction,
};

const LoaderContainer = styled.div.withConfig({ componentId: 'sc-mdat9u-0' })`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
`;

const Centered = styled.div.withConfig({ componentId: 'sc-mdat9u-1' })`
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalRoot = styled.div.withConfig({ componentId: 'sc-mdat9u-2' })`
  background: white;
  max-width: 400px;
  min-width: 340px;
  padding: 32px;
  margin: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
`;

const CloseIconContainer = styled.div.withConfig({ componentId: 'sc-mdat9u-3' })`
  right: 30px;
  position: absolute;
  top: 30px;
  cursor: pointer;
`;

type Props = {
  form: formShape;
  account?: any;
  accountSummary?: any;
  fields?: any;
  handleSubmit?: (...args: any[]) => any;
  handleFormSubmit?: (...args: any[]) => any;
  location?: any;
  onPostSubmit?: (...args: any[]) => any;
  handleDispatchTimeChange?: (...args: any[]) => any;
  userProfile?: any;
  setBookingProfile?: (accountSummary: AccountSummary, userProfileId: string) => void;
  initialValues?: any;
  isSlotFetching?: boolean;
  handleClose?: () => void;
  theme: { palette: WhiteLabelPaletteName };
  fetchLocationSlotsData?: (...args: any[]) => any;
};

type State = any;

class CDPBookingForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showUnderlay: false,
      focusedField: null,
      submitted: false,
      loadingSlots: false,
    };
  }

  componentDidMount = () => {
    const { location, fetchLocationSlotsData } = this.props;
    if (isEmpty(location.slots)) {
      // Some pages, like the pass page, wait to fetch slots until this form is opened
      fetchLocationSlotsData?.(location.id);
      this.setState({ loadingSlots: true });
    }
  };

  componentDidUpdate = (prevProps: any) => {
    if (!this.props.isSlotFetching && this.state.loadingSlots) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ loadingSlots: false });
    }

    if (isEmpty(prevProps.location.slots) && !isEmpty(this.props.location.slots)) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ loadingSlots: false });
    }
  };

  onChangeOfUserProfile = (props: any, clickedUserProfileId: any) =>
    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.setBookingProfile(props.accountSummary, clickedUserProfileId);

  onSubmit = (e: any) => {
    e && e.preventDefault();

    const { initialValues } = this.props;
    let form = this.props.form.getFieldsValue();

    form = deleteUndefinedFields(form);
    form = { ...initialValues, ...form };

    this.setState(
      { submitted: true },
      this.props.form.validateFields((errors: any, values: any) => {
        if (!errors) {
          // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
          return this.props.handleFormSubmit(form, this.props);
        }

        return null;
      })
    );
  };

  getFieldClass = (fieldName: any) => {
    if (this.state.focusedField === fieldName) {
      return s.focusInputContainer;
    }

    return s.blurInputContainer;
  };

  focusField = (fieldName: any) => {
    this.setState({
      showUnderlay: true,
      focusedField: fieldName,
    });
  };

  blurField = () => {
    this.setState({
      showUnderlay: false,
      focusedField: null,
    });
  };

  render() {
    const { loadingSlots } = this.state;
    const symptoms = getFieldObject(SYMPTOMS_FIELD_NAME, this.props, emptyInteractions);
    const appointmentTime = getFieldObject(
      APPOINTMENT_TIME_FIELD_NAME,
      this.props,
      emptyInteractions
    );
    const userProfile = getFieldObject(USER_PROFILE_FIELD_NAME, this.props, emptyInteractions);

    const fill =
      ALL_WHITELABEL_PALETTES[this.props.theme.palette]?.palette.base ?? colors.crunchBerry;

    return (
      <ModalRoot>
        <div className={s.root}>
          <CloseIconContainer onClick={this.props.handleClose}>
            <SmallXSvg fill={fill} />
          </CloseIconContainer>
          <div
            className={this.state.showUnderlay ? s.underlayShown : s.underlayHidden}
            onClick={this.blurField}
          />

          <div className={s.modalHeader}>BOOK A VISIT</div>

          <form onSubmit={this.onSubmit}>
            <div className={s.formFields}>
              {!isEmpty(this.props.userProfile) && (
                <div
                  className={`${s.profileSelector} ${this.getFieldClass(USER_PROFILE_FIELD_NAME)}`}
                >
                  <UserProfileSelector
                    accountSummary={this.props.accountSummary}
                    field={userProfile}
                    handleChangeUserProfile={this.onChangeOfUserProfile}
                    id={USER_PROFILE_FIELD_NAME}
                    inputProps={this.props.form.getFieldProps(USER_PROFILE_FIELD_NAME, {
                      initialValue: this.props.initialValues[USER_PROFILE_FIELD_NAME],
                    })}
                    onBlur={this.blurField}
                    onFocus={this.focusField}
                    s={s}
                    submitted={this.state.submitted}
                    userProfileId={this.props.userProfile.user_profile_id}
                  />
                </div>
              )}
              {loadingSlots ? (
                <LoaderContainer>
                  {/* @ts-expect-error ts-migrate(2769) FIXME: Type 'string' is not assignable to type '"inherit"... Remove this comment to see the full error message */}
                  <CircularProgress color={colors.dorianGrey} />
                </LoaderContainer>
              ) : (
                <div className={this.getFieldClass(APPOINTMENT_TIME_FIELD_NAME)}>
                  <AppointmentTimeInput
                    field={appointmentTime}
                    handleDispatchTimeChange={this.props.handleDispatchTimeChange}
                    id={APPOINTMENT_TIME_FIELD_NAME}
                    inputProps={this.props.form.getFieldProps(APPOINTMENT_TIME_FIELD_NAME, {
                      initialValue: this.props.initialValues[APPOINTMENT_TIME_FIELD_NAME],
                    })}
                    location={this.props.location}
                    onBlur={this.blurField}
                    onFocus={this.focusField}
                    s={s}
                    // @ts-expect-error ts-migrate(2769) FIXME: Property 'submitted' does not exist on type 'Intri... Remove this comment to see the full error message
                    submitted={this.state.submitted}
                  />
                </div>
              )}

              <div className={this.getFieldClass(SYMPTOMS_FIELD_NAME)}>
                <SymptomInput
                  field={symptoms}
                  id={SYMPTOMS_FIELD_NAME}
                  inputProps={this.props.form.getFieldProps(SYMPTOMS_FIELD_NAME, {
                    initialValue: this.props.initialValues[SYMPTOMS_FIELD_NAME],
                  })}
                  onBlur={this.blurField}
                  onFocus={this.focusField}
                  s={s}
                />
              </div>
            </div>

            <Centered>
              <Button
                data-testid="cdpBookingFormSubmitBtn"
                disabled={loadingSlots || !appointmentTime?.value}
                type="submit"
              >
                Continue
              </Button>
            </Centered>
          </form>
        </div>
      </ModalRoot>
    );
  }
}

export default withStyles(s)(CDPBookingForm);
